import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class RxPriorAuthorizationType extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> Financial constructor -', init)
    if (isNil(init)) return undefined
    this._claim_id = init.claim_id
    this._medication = init.medication
    this._requested_by = init.requested_by
    this._new_start_or_cot = init.new_start_or_cot
    this._tried_and_failed_medications = init.tried_and_failed_medications
    this._mhk_rx_case_number = init.mhk_rx_case_number
    this._symptomId = init.symptomId
    this._symptomName = init.symptomName
  }

  static shape = {
    claim_id: PropTypes.string,
    medication: PropTypes.string,
    requested_by: PropTypes.string,
    new_start_or_cot: PropTypes.string,
    tried_and_failed_medications: PropTypes.string,
    mhk_rx_case_number: PropTypes.string,
    symptomId: PropTypes.string,
    symptomName: PropTypes.string
  }

  get claim_id() {
    return this._claim_id
  }

  get medication() {
    return this._medication
  }

  get requested_by() {
    return this._requested_by
  }

  get new_start_or_cot() {
    return this._new_start_or_cot
  }

  get tried_and_failed_medications() {
    return this._tried_and_failed_medications
  }

  get mhk_rx_case_number() {
    return this._mhk_rx_case_number
  }

  get symptomId() {
    return this._symptomId
  }

  get symptomName() {
    return this._symptomName
  }
}

export default RxPriorAuthorizationType
